module.exports = __webpack_public_path__ + "img/12.e89b1e96.svg";